import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { resolveShortUrl } from '@/services/url-shortener';
import { Loader2 } from 'lucide-react';

const ShortUrlRedirect: React.FC = () => {
  const { shortId } = useParams<{ shortId: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  
  useEffect(() => {
    const redirectUrl = async () => {
      if (!shortId) {
        setError('Invalid URL');
        return;
      }
      
      try {
        const originalUrl = await resolveShortUrl(shortId);
        
        if (!originalUrl) {
          setError('This link has expired or is invalid');
          return;
        }
        
        // Redirect to the original URL
        window.location.href = originalUrl;
      } catch (err) {
        console.error('Error resolving short URL:', err);
        setError('An error occurred while resolving the URL');
      }
    };
    
    redirectUrl();
  }, [shortId, navigate]);
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4 text-center">
      {error ? (
        <div className="max-w-md">
          <h1 className="text-2xl font-bold mb-4 text-red-500">Error</h1>
          <p className="mb-4">{error}</p>
          <button
            onClick={() => navigate('/')}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            Go to Homepage
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-center">
          <Loader2 className="h-12 w-12 animate-spin text-primary mb-4" />
          <p className="text-lg">Redirecting you to your destination...</p>
        </div>
      )}
    </div>
  );
};

export default ShortUrlRedirect; 